import { iframeDataBridge } from '@/iframe/iframeDataBridge';

// Delivery Location form values -> legacy deliveryLocationModel (global constructor of the iframe).
// The model is sealed (Object.preventExtensions), so fields are set one by one rather than spread.
// salesHelper.newDeliveryLocation then runs deliveryLocationTranslator.toJsonApi on it.
export function toDeliveryLocationModel(formValues, { organisationId } = {}) {
	const DeliveryLocationModel = iframeDataBridge.getIframeWindow()?.deliveryLocationModel;
	if (!DeliveryLocationModel) throw new Error('deliveryLocationModel is not available in the legacy iframe');

	const dl = new DeliveryLocationModel();

	dl.deliveryLocationTypeId = formValues.deliveryLocationTypeId ?? 0;
	dl.companyName = formValues.companyName ?? '';
	dl.reference = dl.companyName;
	dl.label = dl.companyName;
	dl.firstname = formValues.firstName ?? '';
	dl.lastname = formValues.lastName ?? '';
	dl.email = formValues.email ?? '';
	dl.addressLine = formValues.addressLine ?? '';
	dl.postcode = formValues.postcode ?? '';
	dl.city = formValues.city ?? '';
	dl.country = formValues.country ?? '';
	dl.phoneNumber = formValues.phoneNumber ?? '';
	dl.faxNumber = formValues.faxNumber ?? '';
	dl.identificationNumber = formValues.identificationNumber ?? '';
	dl.accountId = formValues.accountId ?? 0;
	dl.groupId = formValues.groupId ?? 0;
	dl.distributionChannel = formValues.distributionChannel ?? 0;
	dl.channelId = formValues.channelId ?? 0;
	dl.POSTypeId = formValues.POSTypeId ?? 0;
	dl.lat = formValues.lat ?? null;
	dl.lng = formValues.lng ?? null;
	if (organisationId) dl.organisations = [organisationId];

	return dl;
}
